export default {
  itemAvatarIcon: {
    height: '2.5em',
    width: '2.5em',
  },
  avatarContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'stretch',
    alignItems: 'center',
    justifyContent: 'center',
    alignConent: 'center',
    height: '100%',
    width: '100%',
  },
};
